// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root{--primaryColor: #334969;--page_bg: #f1efee;--lines: #ebedf1;--primaryHover: #2e425f;--secondaryHover: #ebedf0;--primaryActive: #293a54;--secondaryActive: #d6dbe1;--disputeFieldsBg:#f8fbf9}\n", ""]);
// Exports
module.exports = exports;
